class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      if (!parsedState.sections || !parsedState.sections[section.id]) return;

      if (section.id === "cart-count-header") {
        const newElement = this.getSectionDOM(parsedState.sections[section.id], section.selector);
        if (newElement && sectionElement.parentNode) {
          sectionElement.parentNode.replaceChild(newElement, sectionElement);
        }
      } else {
        sectionElement.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    syncRecommendationButtons();
    syncPdpStickyCartVisibility();
  }

  getSectionInnerHTML(html, selector) {
    const element = new DOMParser().parseFromString(html, "text/html").querySelector(selector);
    return element ? element.innerHTML : "";
  }

  getSectionDOM(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: "main-cart-items",
        selector: ".main-cart-items",
      },
      {
        id: "footer-cart-drawer",
        section: "footer-cart-drawer",
        selector: ".footer-cart-drawer",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".cart-icon-bubble",
      },
      {
        id: "cart-count-header",
        section: "cart-count-header",
        selector: "#cart-count-header",
      },
    ];
  }

  addAttributes(attributes) {
    console.log("addAttributes", attributes);
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: "main-cart-items",
        selector: ".main-cart-items",
      },
      {
        id: "footer-cart-drawer",
        section: "footer-cart-drawer",
        selector: ".footer-cart-drawer",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".cart-icon-bubble",
      },
      {
        id: "cart-count-header",
        section: "cart-count-header",
        selector: "#cart-count-header",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

/* =========================
   Cart drawer recommendations
========================= */

(function () {
  if (window.__wiseCartRecBound) return;
  window.__wiseCartRecBound = true;

  function getRecommendationCards(scope = document) {
    return scope.querySelectorAll('.footer-cart-drawer .cart-rec-card');
  }

  function getRecommendationCard(target) {
    return target.closest('.cart-rec-card');
  }

  function getVariantIdFromCard(card) {
    if (!card) return '';

    const select = card.querySelector('[data-rec-select]');
    const addBtn = card.querySelector('[data-rec-add]');
    const defaultVariantId =
      (addBtn && addBtn.dataset.defaultVariantId) ||
      card.dataset.defaultVariantId ||
      '';

    if (select && !select.classList.contains('hidden')) {
      return select.value || '';
    }

    return defaultVariantId;
  }

  function setButtonState(card) {
    if (!card) return;

    const addBtn = card.querySelector('[data-rec-add]');
    if (!addBtn) return;

    const variantId = getVariantIdFromCard(card);

    if (variantId) {
      addBtn.disabled = false;
      addBtn.removeAttribute('disabled');
    } else {
      addBtn.disabled = true;
      addBtn.setAttribute('disabled', 'disabled');
    }
  }

  function syncRecommendationButtons(scope = document) {
    getRecommendationCards(scope).forEach((card) => {
      setButtonState(card);
    });
  }

  function syncPdpStickyCartVisibility() {
    const pdpSticky = document.querySelector('[id^="MobileStickyCart-"]');
    if (!pdpSticky) return;

    const cartDrawerEl = document.querySelector('cart-drawer');
    const drawerInner = document.querySelector('cart-drawer .drawer__inner');
    const footerDrawer = document.querySelector('#footer-cart-drawer');

    const isDrawerVisible =
      (cartDrawerEl && (
        cartDrawerEl.classList.contains('active') ||
        cartDrawerEl.hasAttribute('open') ||
        cartDrawerEl.offsetParent !== null
      )) ||
      (drawerInner && drawerInner.offsetParent !== null) ||
      (footerDrawer && footerDrawer.offsetParent !== null);

    if (isDrawerVisible) {
      pdpSticky.style.display = 'none';
    } else {
      pdpSticky.style.display = '';
    }
  }

  async function refreshCartDrawer(addedItem) {
    const drawer = document.querySelector('cart-drawer');

    if (!drawer || typeof drawer.renderContents !== 'function') {
      openCartDrawer();
      return;
    }

    const sectionIds = drawer
      .getSectionsToRender()
      .map((section) => section.id)
      .join(',');

    const sections = await fetch(`/?sections=${sectionIds}`, {
      headers: {
        'Accept': 'application/json'
      }
    }).then((res) => res.json());

    drawer.renderContents({
      id: addedItem && addedItem.id ? addedItem.id : null,
      sections: sections
    });

    openCartDrawer();
  }

  function openCartDrawer() {
    const cartButton = Array.from(document.querySelectorAll('button')).find((button) => {
      const clickAttr =
        button.getAttribute('@click') ||
        button.getAttribute('x-on:click') ||
        button.getAttribute('data-click') ||
        '';

      return clickAttr.includes('cart = true') || clickAttr.includes('cart=true');
    });

    if (cartButton) {
      cartButton.click();
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.add('active');
      drawer.setAttribute('open', 'open');
    }

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('cart-drawer-open');

    syncPdpStickyCartVisibility();
  }

  document.addEventListener('change', function (e) {
    const select = e.target.closest('[data-rec-select]');
    if (!select) return;

    const card = getRecommendationCard(select);
    if (!card) return;

    setButtonState(card);
  });

  document.addEventListener('input', function (e) {
    const select = e.target.closest('[data-rec-select]');
    if (!select) return;

    const card = getRecommendationCard(select);
    if (!card) return;

    setButtonState(card);
  });

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-rec-add]');

    if (!btn) {
      setTimeout(() => {
        syncPdpStickyCartVisibility();
      }, 50);

      setTimeout(() => {
        syncPdpStickyCartVisibility();
      }, 250);

      return;
    }

    const card = getRecommendationCard(btn);
    if (!card) return;

    const variantId = getVariantIdFromCard(card);
    if (!variantId) {
      setButtonState(card);
      return;
    }

    btn.disabled = true;
    btn.setAttribute('disabled', 'disabled');

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })
      });

      if (!response.ok) {
        throw new Error('Add to cart failed');
      }

      const addedItem = await response.json();

      await refreshCartDrawer(addedItem);

      setButtonState(card);
    } catch (error) {
      console.error(error);
      setButtonState(card);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncRecommendationButtons();
    syncPdpStickyCartVisibility();
  });

  document.addEventListener('shopify:section:load', function () {
    syncRecommendationButtons();
    syncPdpStickyCartVisibility();
  });

  const observer = new MutationObserver(function () {
    syncRecommendationButtons();
    syncPdpStickyCartVisibility();
  });

  document.addEventListener('DOMContentLoaded', function () {
    const drawer = document.querySelector('.footer-cart-drawer');

    if (drawer) {
      observer.observe(drawer, {
        childList: true,
        subtree: true
      });
    }

    const bodyObserver = new MutationObserver(function () {
      syncPdpStickyCartVisibility();
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'open']
    });
  });
})();